export default __webpack_public_path__ + "static/media/elementary-sessions-icon.bd42e099.png";